import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

import {
  DISABLE_REMOTE_LOGIN_FAILURE,
  DISABLE_REMOTE_LOGIN_REQUEST,
  DISABLE_REMOTE_LOGIN_SUCCESS,
} from 'salon/actions';

const disableRemoteLogin = ({ salonId, stylistId }) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    authenticated: true,
    endpoint: `salon/${salonId}/stylist/${stylistId}/disable_login/`,
    config: { method: 'POST', headers: { 'Content-Type': 'application/json' } },
    types: [DISABLE_REMOTE_LOGIN_REQUEST, DISABLE_REMOTE_LOGIN_SUCCESS, DISABLE_REMOTE_LOGIN_FAILURE],
  },
});

// noinspection JSUnusedGlobalSymbols
export default disableRemoteLogin;
